import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../ReactComponent';
import { Box, Button, Tooltip } from '@mui/material';
import AutoComplete from '@/components/AutoComplete';
import { Settings } from '@mui/icons-material';
import AutoTextoOpcoes from './AutoTextoOpcoes';

class AutoTexto extends ReactComponent {
    openOpcoesDialog = false;
    opcaoSelecionada;

    constructor(props) {
        super(props);

        makeObservable(this, {
            openOpcoesDialog: observable,
            opcaoSelecionada: observable,
            opcoes: computed,
            temOpcoes: computed,
            isDesabilitado: computed,
            handleAlteracaoOpcaoSelecionada: action,
            handleOpenOpcoesDialog: action,
            handleCloseOpcoesDialog: action
        });
    }

    get opcoes() {
        return this.preSessaoStore.autoTexto.map((item) => ({
            valor: item.autoTexto,
            texto: item.nomeAutoTexto,
            id: item.id
        }));
    }

    get temOpcoes() {
        return this.opcoes && this.opcoes.length > 0;
    }

    get isDesabilitado() {
        return this.observableProps.desabilitado || !this.temOpcoes;
    }

    handleAlteracaoOpcaoSelecionada = (opcao) => {
        this.opcaoSelecionada = opcao;
    };

    handleOpenOpcoesDialog = () => {
        this.openOpcoesDialog = true;
    };

    handleCloseOpcoesDialog = () => {
        this.openOpcoesDialog = false;
    };

    handleIncluirOpcaoSelecionada = () => {
        if (this.observableProps.onIncluirOpcaoSelecionada && this.opcaoSelecionada) {
            this.observableProps.onIncluirOpcaoSelecionada(this.opcaoSelecionada.valor);
        }
    };

    handleIncluirOpcaoSelecionadaComEnter = (value) => {
        if (this.opcaoSelecionada && this.opcaoSelecionada.texto === value) {
            this.handleIncluirOpcaoSelecionada();
        }
    };

    render() {
        return (
            <>
                <Box sx={{ display: 'flex', gap: 0.5, my: 0.5, ...this.observableProps.estilosWrapper }}>
                    <Tooltip title="Gerenciar opções do Dec-Pad">
                        <Box component="span">
                            <Button
                                onClick={this.handleOpenOpcoesDialog}
                                sx={{ px: 1, py: '7px', minWidth: 'auto' }}
                                variant="outlined"
                            >
                                <Settings />
                            </Button>
                        </Box>
                    </Tooltip>
                    <AutoComplete
                        value={this.opcaoSelecionada?.texto}
                        options={this.opcoes}
                        label="Pesquisar Dec-Pad"
                        onChange={this.handleAlteracaoOpcaoSelecionada}
                        onEnterKeyDown={this.handleIncluirOpcaoSelecionadaComEnter}
                        disabled={this.isDesabilitado}
                        style={this.observableProps.estiloAutoComplete}
                    />
                    <Button
                        variant="contained"
                        onClick={this.handleIncluirOpcaoSelecionada}
                        disabled={this.isDesabilitado}
                    >
                        Incluir
                    </Button>
                </Box>
                {this.openOpcoesDialog && <AutoTextoOpcoes handleCloseDialog={this.handleCloseOpcoesDialog} />}
            </>
        );
    }
}

export default inject('stores')(observer(AutoTexto));
